import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-rectangle-icon]',
  template: `
    <svg:path
      d="M13.9062 4.0625H2.09375V11.9375H13.9062V4.0625ZM0.78125 4.0625V3.9375L0.8125 3.79688L0.84375 3.67188L0.890625 3.5625L0.9375 3.4375L1 3.32812L1.07812 3.23438L1.17188 3.14062L1.26562 3.04688L1.35938 2.98438L1.46875 2.90625L1.57812 2.85938L1.70312 2.8125L1.82812 2.78125L1.95312 2.76562L2.09375 2.75H13.9062L14.0469 2.76562L14.1719 2.78125L14.2969 2.8125L14.4219 2.85938L14.5312 2.90625L14.6406 2.98438L14.7344 3.04688L14.8281 3.14062L14.9219 3.23438L15 3.32812L15.0625 3.4375L15.1094 3.5625L15.1562 3.67188L15.1875 3.79688L15.2188 3.9375V4.0625V11.9375V12.0625L15.1875 12.2031L15.1562 12.3281L15.1094 12.4375L15.0625 12.5625L15 12.6719L14.9219 12.7656L14.8281 12.8594L14.7344 12.9531L14.6406 13.0156L14.5312 13.0938L14.4219 13.1406L14.2969 13.1875L14.1719 13.2188L14.0469 13.2344L13.9062 13.25H2.09375L1.95312 13.2344L1.82812 13.2188L1.70312 13.1875L1.57812 13.1406L1.46875 13.0938L1.35938 13.0156L1.26562 12.9531L1.17188 12.8594L1.07812 12.7656L1 12.6719L0.9375 12.5625L0.890625 12.4375L0.84375 12.3281L0.8125 12.2031L0.78125 12.0625V11.9375V4.0625Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RectangleIcon {
  readonly viewBox = input<string>('0 0 16 16');
  readonly extraClass = input<string>('');
}
